<script>
import Base from '@/views/succezz/components/common-addon.vue';
export default {
  extends: Base,
  computed: {
    showPromotes() {
      return this.$context.is.buyNow || this.$context.is.basic2pro
    },
  },
};
</script>
